import { render, staticRenderFns } from "./Blankboard.vue?vue&type=template&id=5f098185"
import script from "./Blankboard.vue?vue&type=script&lang=js"
export * from "./Blankboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports